export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -88, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

export const PHONE = "480-940-6023";
export const PHONE_TEL = "tel:4809406023";
export const GOOGLE_MAPS_URL =
  "https://www.google.com/maps/search/?api=1&query=Oxford+Cleaners+5865+W+Ray+Rd+Chandler+AZ";

export const SERVICE_AREAS = ["Chandler", "Gilbert", "Tempe", "Ahwatukee", "Sun Lakes", "Maricopa"];

export const ZIP_MAP = {
  Chandler: ["85224", "85225", "85226", "85244", "85246", "85248", "85249", "85286"],
  Gilbert: ["85233", "85234", "85295", "85296", "85297", "85298"],
  Tempe: ["85280", "85281", "85282", "85283", "85284", "85285", "85287", "85288"],
  Ahwatukee: ["85044", "85045", "85048"],
  "Sun Lakes": ["85248"],
  Maricopa: ["85138", "85139", "85238", "85239"],
};

export const checkZip = (zip) => {
  for (const [city, zips] of Object.entries(ZIP_MAP)) {
    if (zips.includes(zip)) return city;
  }
  return null;
};

// Maricopa route days: Tuesday (2) & Friday (5). Owner can change these.
export const MARICOPA_ROUTE_DAYS = [2, 5];
export const MARICOPA_ROUTE_LABEL = "Tuesdays & Fridays";

export const nextMaricopaRouteDates = (count = 4) => {
  const dates = [];
  const d = new Date();
  d.setDate(d.getDate() + 1);
  while (dates.length < count) {
    if (MARICOPA_ROUTE_DAYS.includes(d.getDay())) {
      dates.push(new Date(d));
    }
    d.setDate(d.getDate() + 1);
  }
  return dates;
};

export const fmtRouteDate = (d) =>
  d.toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric" });

// Seasonal promo — flips to Winter Special automatically on Nov 1, 2026.
export const PROMO = (() => {
  const winter = new Date() >= new Date("2026-11-01T00:00:00");
  return winter
    ? { key: "winter", name: "Winter Special", endsLabel: "January 31", endsISO: "2027-01-31T23:59:59" }
    : { key: "fall", name: "Fall Special", endsLabel: "October 31", endsISO: "2026-10-31T23:59:59" };
})();

// SEO page metadata (owner-approved copy)
export const HOME_TITLE = "Oxford Cleaners Chandler AZ | Dry Cleaners, Free Pickup";
export const HOME_META =
  "Veteran-owned dry cleaners in Chandler, AZ. Free pickup & delivery Mon–Sat, back in ~48 hrs. Dry cleaning, alterations, wash & fold. 480-940-6023";

export const SERVICE_LIST = [
  "Dry cleaning: suits, dresses, blouses, slacks, uniforms",
  "Laundered and pressed shirts",
  "Wash & fold by the bag",
  "Comforters, blankets and duvets",
  "Curtains, drapes and table linens",
  "Alterations and repairs: hems, zippers, tailoring",
  "Wedding dress cleaning and preservation",
  "Leather and suede care",
];

const HOW_WORKS_DEFAULT = [
  "Book online or call 480-940-6023.",
  "Leave your bag on the porch, we pick it up.",
  "Get it back cleaned, pressed and on hangers in about 48 hours.",
];

const WHY_CHOOSE_DEFAULT = [
  "Veteran & family-owned — Wais served, and runs the shop the same way",
  "Redo-it-free guarantee: if it's not right, we make it right",
  "You talk to Wais directly — never a call center",
  "Free Class A uniform & American flag cleaning, always",
];

const cityFaq = (city) => [
  {
    q: `Do you pick up dry cleaning in ${city}?`,
    a: `Yes. Pickup and delivery are free across ${city} with no minimum order.`,
  },
  { q: "How long does it take?", a: "About 48 hours from pickup to delivery." },
  {
    q: "Where is your shop?",
    a: "5865 W Ray Rd, Suite 3, Chandler, AZ 85226. Drop-offs are welcome Mon–Fri 7am–5pm and Sat 10am–2pm.",
  },
];

export const SEO_PAGES = [
  {
    kind: "city",
    city: "Chandler",
    path: "/chandler-dry-cleaning-pickup-delivery",
    title: "Chandler Dry Cleaning Pickup & Delivery | Free",
    meta: "Chandler dry cleaning picked up at your door, free. Back in ~48 hrs. Suits, shirts, comforters & alterations. Local shop on Ray Rd since day one.",
    h1: "Chandler Dry Cleaners with Free Pickup & Delivery",
    intro:
      "Our shop is right here on Ray Rd, so Chandler gets our fastest turnaround. Drop off at the counter or skip the trip completely. We pick up at your door for free and bring everything back pressed in about 48 hours.",
    homeLink: true,
    howItWorks: [
      "Book online or call 480-940-6023.",
      "Leave your bag on the porch, we pick it up.",
      "Get it back cleaned, pressed and on hangers in about 48 hours.",
    ],
    neighborhoodsH2: "Chandler neighborhoods and ZIP codes we serve",
    neighborhoods:
      "West Chandler, Downtown Chandler, Ocotillo, Fulton Ranch, Clemente Ranch, Andersen Springs, Sun Groves, Cooper Commons",
    zips: ["85224", "85225", "85226", "85248", "85249", "85286"],
    whyChoose: [
      "Veteran & family-owned — Wais served, and runs the shop the same way",
      "Redo-it-free guarantee: if it's not right, we make it right",
      "You talk to Wais directly — never a call center",
      "Free Class A uniform & American flag cleaning, always",
    ],
    faq: [
      {
        q: "Do you pick up dry cleaning in Chandler?",
        a: "Yes. Pickup and delivery are free across Chandler with no minimum order.",
      },
      { q: "How long does it take?", a: "About 48 hours from pickup to delivery." },
      {
        q: "Where is your shop?",
        a: "5865 W Ray Rd, Suite 3, Chandler, AZ 85226. Drop-offs are welcome Mon–Fri 7am–5pm and Sat 10am–2pm.",
      },
    ],
    visitShop: true,
    bookCta: "Book my free Chandler pickup",
  },
  {
    kind: "city",
    city: "Maricopa",
    path: "/maricopa-dry-cleaning-pickup-delivery",
    title: "Dry Cleaning Pickup & Delivery in Maricopa, AZ | Free",
    meta: "No dry cleaner in Maricopa? We come to you. Free pickup & delivery every Tue & Fri in 85138, 85139, 85238, 85239. Veteran-owned. Book in 30 sec.",
    h1: "Dry Cleaning Pickup & Delivery in Maricopa, AZ",
    intro:
      "Maricopa doesn't have a dry cleaner. Now it doesn't need one. Oxford Cleaners picks up at your door every Tuesday and Friday and brings everything back cleaned and pressed in about 48 hours. Pickup and delivery are always free, with no minimums.",
    neighbor: {
      h2: "Owned by your Maricopa neighbor",
      text: "I'm Wais Kushkaki, an Army veteran, and I live right here in Maricopa with my family. Our shop is in Chandler, but I drive the 347 every day. It made no sense that my neighbors had to do the same just to get a shirt pressed. So we bring the dry cleaner to you. We're also proud sponsors of the Maricopa Rams football stadium.",
    },
    howItWorks: [
      "Book online or call 480-940-6023. Choose Tuesday or Friday.",
      "Leave your bag on the porch. We pick it up.",
      "Get it back cleaned, pressed and on hangers in about 48 hours.",
    ],
    neighborhoodsH2: "Maricopa ZIP codes and neighborhoods we serve",
    neighborhoods:
      "Rancho El Dorado, The Villages, Province, Tortosa, Glennwilde, Homestead, Senita, Cobblestone Farms, Alterra, Acacia Crossings, Maricopa Meadows, Desert Passage, Santa Rosa Springs and Sorrento",
    zips: ["85138", "85139", "85238", "85239"],
    veteran: {
      h2: "Veterans in Maricopa",
      text: "Class A uniforms and American flags are cleaned free, always. Just add them to your pickup.",
    },
    faq: [
      {
        q: "Is there a dry cleaner in Maricopa, AZ?",
        a: "There's no dry cleaning plant in Maricopa. Oxford Cleaners serves Maricopa with free pickup and delivery every Tuesday and Friday from our Chandler shop.",
      },
      {
        q: "How much does pickup and delivery cost?",
        a: "Nothing. Pickup and delivery are free with no minimum order.",
      },
      {
        q: "How fast will I get my clothes back?",
        a: "About 48 hours. Pickups on Tuesday come back Friday, and Friday pickups come back the next Tuesday.",
      },
      {
        q: "Do I need to be home?",
        a: "No. Leave your bag on the porch and we'll text you when we pick up and drop off.",
      },
    ],
    bookCta: "Book my Maricopa pickup",
  },
  {
    kind: "city",
    city: "Gilbert",
    path: "/gilbert-dry-cleaners",
    title: "Gilbert AZ Dry Cleaners | Free Pickup & Delivery",
    meta: "Dry cleaning, wash & fold and alterations picked up at your Gilbert door, free. Back in ~48 hrs. Veteran & family-owned Oxford Cleaners.",
    h1: "Gilbert Dry Cleaners with Free Pickup & Delivery",
    intro:
      "Gilbert families are busy. Between school runs and practice, nobody wants another stop. We pick up your dry cleaning, comforters and wash & fold at the door and bring it back fresh, with free pickup and delivery on every order.",
    howItWorks: HOW_WORKS_DEFAULT,
    neighborhoodsH2: "Gilbert neighborhoods and ZIP codes we serve",
    neighborhoods: "Agritopia, Val Vista Lakes, Power Ranch, Morrison Ranch, Seville, Heritage District",
    zips: ["85233", "85234", "85295", "85296", "85297", "85298"],
    whyChoose: WHY_CHOOSE_DEFAULT,
    faq: cityFaq("Gilbert"),
    bookCta: "Book my free Gilbert pickup",
  },
  {
    kind: "city",
    city: "Tempe",
    path: "/tempe-dry-cleaners",
    title: "Tempe Dry Cleaners | Free Pickup & Delivery | Oxford",
    meta: "Tempe dry cleaning without the drive. Free doorstep pickup & delivery, ~48-hr turnaround, suits, shirts, comforters & alterations.",
    h1: "Tempe Dry Cleaners with Free Pickup & Delivery",
    intro:
      "From ASU faculty to South Tempe professionals, we keep work clothes sharp without the trip. Free doorstep pickup and delivery, suits and shirts pressed crisp, back in about 48 hours.",
    howItWorks: HOW_WORKS_DEFAULT,
    neighborhoodsH2: "Tempe neighborhoods and ZIP codes we serve",
    neighborhoods: "South Tempe, The Lakes, Kiwanis Park area, Warner Ranch, ASU area",
    zips: ["85281", "85282", "85283", "85284"],
    whyChoose: WHY_CHOOSE_DEFAULT,
    faq: cityFaq("Tempe"),
    bookCta: "Book my free Tempe pickup",
  },
  {
    kind: "city",
    city: "Ahwatukee",
    path: "/ahwatukee-dry-cleaners",
    title: "Ahwatukee Dry Cleaners | Free Pickup & Delivery",
    meta: "Ahwatukee's pickup & delivery dry cleaner. Free, Mon–Sat, back in ~48 hrs. Suits, dresses, bedding & alterations. Veteran-owned.",
    h1: "Ahwatukee Dry Cleaners with Free Pickup & Delivery",
    intro:
      "Our shop on Ray Rd is just across I-10 from Ahwatukee, so you get some of the fastest turnaround on our routes. Skip the drive entirely: we pick up at your door, free, and bring it back pressed in about 48 hours.",
    howItWorks: HOW_WORKS_DEFAULT,
    neighborhoodsH2: "Ahwatukee neighborhoods and ZIP codes we serve",
    neighborhoods: "Ahwatukee Foothills, Club West, Mountain Park Ranch, Lakewood, The Foothills, Warner Ranch",
    zips: ["85044", "85045", "85048"],
    whyChoose: WHY_CHOOSE_DEFAULT,
    faq: cityFaq("Ahwatukee"),
    bookCta: "Book my free Ahwatukee pickup",
  },
  {
    kind: "city",
    city: "Sun Lakes",
    path: "/sun-lakes-dry-cleaners",
    title: "Sun Lakes Dry Cleaners | Free Pickup & Delivery",
    meta: "Sun Lakes dry cleaning delivered to your door, free. Suits, linens, drapes, comforters & alterations. Veteran & family-owned.",
    h1: "Sun Lakes Dry Cleaners with Free Pickup & Delivery",
    intro:
      "Sun Lakes residents shouldn't have to haul drapes, table linens and heavy comforters across town. We pick them up at your door, clean them with care, and bring them back ready to hang or use, free.",
    howItWorks: HOW_WORKS_DEFAULT,
    neighborhoodsH2: "Sun Lakes neighborhoods and ZIP codes we serve",
    neighborhoods: "Sun Lakes, Oakwood, Ironwood, Cottonwood, Palo Verde",
    zips: ["85248"],
    whyChoose: WHY_CHOOSE_DEFAULT,
    faq: cityFaq("Sun Lakes"),
    bookCta: "Book my free Sun Lakes pickup",
  },
  {
    kind: "service",
    city: null,
    path: "/wedding-dress-cleaning-preservation",
    title: "Wedding Dress Cleaning & Preservation | Chandler AZ",
    meta: "Hand-inspected gown cleaning, stain treatment & museum-style preservation boxing in Chandler. Free pickup across the East Valley. Free consultation.",
    h1: "Wedding dress cleaning & preservation in Chandler, AZ",
    intro:
      "Your gown carried the day — we'll carry it forever. Hand-inspected cleaning, careful stain treatment, and museum-style preservation boxing, with free pickup across the East Valley.",
    bullets: [
      "Hand-inspected, fabric-safe cleaning",
      "Acid-free, museum-style preservation box",
      "Free pickup & delivery + free consultation",
    ],
  },
];

export const CITY_LINKS = Object.fromEntries(
  SEO_PAGES.filter((p) => p.kind === "city").map((p) => [p.city, p.path])
);

// Lightweight reference used on city pages (the full block lives on the homepage).
export const BUSINESS_REF = {
  "@context": "https://schema.org",
  "@type": "DryCleaningOrLaundry",
  "@id": "https://oxford-cleaners.com/#business",
};

// Full business schema — homepage only (owner-approved facts, no ratings).
export const BUSINESS_JSONLD = {
  "@context": "https://schema.org",
  "@type": "DryCleaningOrLaundry",
  "@id": "https://oxford-cleaners.com/#business",
  name: "Oxford Cleaners",
  description:
    "Veteran and family-owned dry cleaner in Chandler, AZ offering dry cleaning, wash and fold, alterations, comforter cleaning, leather care, wedding dress preservation, and free pickup and delivery across Chandler, Gilbert, Tempe, Ahwatukee, Sun Lakes and Maricopa.",
  url: "https://oxford-cleaners.com/",
  telephone: "+1-480-940-6023",
  email: "oxfordcleanersaz@gmail.com",
  priceRange: "$$",
  slogan: "Clean clothes. Zero errands. Free delivery.",
  image: "https://oxford-cleaners.com/images/branded_van.png",
  logo: "https://oxford-cleaners.com/images/oxford-card.png",
  address: {
    "@type": "PostalAddress",
    streetAddress: "5865 W Ray Rd, Suite 3",
    addressLocality: "Chandler",
    addressRegion: "AZ",
    postalCode: "85226",
    addressCountry: "US",
  },
  openingHoursSpecification: [
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
      opens: "07:00",
      closes: "17:00",
    },
    { "@type": "OpeningHoursSpecification", dayOfWeek: "Saturday", opens: "10:00", closes: "14:00" },
  ],
  areaServed: [
    { "@type": "City", name: "Chandler, AZ" },
    { "@type": "City", name: "Gilbert, AZ" },
    { "@type": "City", name: "Tempe, AZ" },
    { "@type": "Place", name: "Ahwatukee, Phoenix, AZ" },
    { "@type": "Place", name: "Sun Lakes, AZ" },
    { "@type": "City", name: "Maricopa, AZ" },
  ],
  founder: { "@type": "Person", name: "Wais Kushkaki" },
  sameAs: [
    "https://www.facebook.com/profile.php?id=61589268029945",
    "https://www.instagram.com/oxfordcleanersaz2026/",
  ],
  hasOfferCatalog: {
    "@type": "OfferCatalog",
    name: "Dry cleaning and laundry services",
    itemListElement: [
      {
        "@type": "Offer",
        price: "0",
        priceCurrency: "USD",
        itemOffered: { "@type": "Service", name: "Free pickup and delivery" },
      },
      { "@type": "Offer", itemOffered: { "@type": "Service", name: "Dry cleaning and pressing" } },
      { "@type": "Offer", itemOffered: { "@type": "Service", name: "Wash and fold" } },
      { "@type": "Offer", itemOffered: { "@type": "Service", name: "Comforter and bedding cleaning" } },
      { "@type": "Offer", itemOffered: { "@type": "Service", name: "Alterations and repairs" } },
      { "@type": "Offer", itemOffered: { "@type": "Service", name: "Wedding dress cleaning and preservation" } },
      { "@type": "Offer", itemOffered: { "@type": "Service", name: "Leather and suede care" } },
      { "@type": "Offer", itemOffered: { "@type": "Service", name: "Curtain and household linen cleaning" } },
    ],
  },
};
